import React from 'react';
import { Link } from 'react-router-dom';
import Logo2 from '../../assets/Logo2.png';

const LandingPage = () => {
  return (
    <div className="bg-slate-50 text-slate-800 min-h-screen font-sans selection:bg-blue-200">
      
      {/* Navigation */}
      <nav className="w-full bg-white/80 backdrop-blur-md border-b border-slate-200 fixed top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 md:px-6 h-16 flex justify-between items-center">
          
          {/* Logo Section */}
          <Link to="/" className="flex items-center gap-2">
            <div className="w-11 h-11 bg-white rounded-xl flex items-center justify-center shadow-md shadow-blue-600/20 flex-shrink-0 overflow-hidden">
              <img src={Logo2} alt="ReviewMate logo" className="w-full h-full object-contain rounded-xl scale-150" />
            </div>
            {/* Text is visible on all screens now */}
            <span className="font-bold text-lg md:text-xl text-slate-900 tracking-tight">ReviewMate</span>
          </Link>
          
          {/* Buttons Section */}
          <div className="flex items-center gap-2 md:gap-4">
            {/* Log In - Visible on Mobile now */}
            <Link to="/login" className="text-xs md:text-sm font-medium text-slate-600 hover:text-blue-600 px-2 transition-colors">
              Log In
            </Link>
            
            {/* Get Started - Visible on Mobile */}
            <Link to="/register" className="bg-blue-600 text-white text-xs md:text-sm font-medium px-4 py-2 md:px-5 md:py-2.5 rounded-full hover:bg-blue-700 transition-all shadow-lg shadow-blue-600/20 hover:shadow-blue-600/40 whitespace-nowrap">
              Get Started
            </Link>
          </div>
        </div>
      </nav>

      {/* Main Hero */}
      <main className="pt-32 md:pt-40 pb-20 px-6 text-center">
        <div className="max-w-4xl mx-auto">
          
          {/* Heading */}
          <h1 className="text-4xl md:text-7xl font-extrabold text-slate-900 tracking-tight mb-8 leading-tight">
            Turn Chaos into <br />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-cyan-500">
              Certified Knowledge.
            </span>
          </h1>

          {/* Subtext */}
          <p className="text-base md:text-xl text-slate-500 mb-10 max-w-2xl mx-auto leading-relaxed">
            Upload your messy notes. Let AI summarize them into reviewers. Secure your ownership on the Blockchain.
          </p>

          {/* CTA Buttons - Center aligned */}
          <div className="flex justify-center items-center">
            <Link to="/register" className="w-full sm:w-auto bg-blue-600 text-white px-8 py-3.5 rounded-xl font-semibold text-lg hover:bg-blue-700 transition-all shadow-xl shadow-blue-600/20 hover:-translate-y-1">
              Start Studying Free
            </Link>
          </div>
        </div>

        {/* Feature Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto mt-20 md:mt-24 text-left">
          {/* Feature 1 */}
          <div className="bg-white p-6 md:p-8 rounded-2xl border border-slate-100 shadow-sm hover:shadow-md transition-shadow group">
            <div className="w-12 h-12 bg-orange-100 text-orange-600 rounded-xl flex items-center justify-center text-xl mb-6 group-hover:scale-110 transition-transform">
              <i className="fa-solid fa-wand-magic-sparkles"></i>
            </div>
            <h3 className="font-bold text-xl text-slate-900 mb-3">AI Summarization</h3>
            <p className="text-slate-500 leading-relaxed text-sm md:text-base">
              Convert 10-page PDFs into 1-page high-yield summaries instantly using our NLP engine.
            </p>
          </div>

          {/* Feature 2 */}
          <div className="bg-white p-6 md:p-8 rounded-2xl border border-slate-100 shadow-sm hover:shadow-md transition-shadow group">
            <div className="w-12 h-12 bg-green-100 text-green-600 rounded-xl flex items-center justify-center text-xl mb-6 group-hover:scale-110 transition-transform">
              <i className="fa-solid fa-shield-halved"></i>
            </div>
            <h3 className="font-bold text-xl text-slate-900 mb-3">Blockchain Secured</h3>
            <p className="text-slate-500 leading-relaxed text-sm md:text-base">
              Your reviewers are minted as assets. Prove ownership and track usage on the chain.
            </p>
          </div>

        </div>
      </main>

      {/* Footer */}
      <footer className="w-full bg-white border-t border-slate-200 py-8 mt-12 text-center text-sm text-slate-500">
        <div className="flex flex-col md:flex-row justify-center items-center gap-4">
          <span>&copy; {new Date().getFullYear()} ReviewMate. All rights reserved.</span>
          <div className="flex gap-4">
            <Link to="/terms" className="hover:text-blue-600 transition-colors">Terms of Service</Link>
            <Link to="/privacy-policy" className="hover:text-blue-600 transition-colors">Privacy Policy</Link>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default LandingPage;
